import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const FaqAreaOne = () => {
  return (
    <>
      {/*==================== Faq area start ====================*/}
      <div
        className='faq-area faq-area-margin-top bg-cover pd-top-90 pd-bottom-110'
        style={{ backgroundImage: 'url("./assets/img/bg/3.png")' }}
      >
        <div className='container'>
          <div className='row pd-top-120'>
            <div
              className='col-xl-5 col-lg-6 col-md-8 order-lg-last'
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='about-thumb-inner pt-lg-3'>
                <img
                  className='main-img rounded'
                  src='assets/img/about/mission.png'
                  alt='img'
                />
              </div>
            </div>
            <div
              className='col-xl-7 col-lg-6'
              data-aos='fade-right'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mb-0 mt-4 mt-lg-0'>
                <h6 className='sub-title'>OUR MISSION</h6>
                <h2 className='title'>
                  Creating <span>Forging's</span> Masterpieces
                </h2>
                <p className='content mb-4'>
                  We will strive to attain leadership in the markets we choose to serve by creating innovative and differentiated products that would be molded with impeccable quality.
                </p>
                <div className='row'>
                  <div className='col-md-12'>
                    <ul className='single-list-inner style-check style-heading style-check mb-3'>
                      <li>
                        <FaCheckCircle /> By being driven by market need
                      </li>
                      <li>
                        <FaCheckCircle /> By innovating
                      </li>
                      <li>
                        <FaCheckCircle /> By improving continuously
                      </li>
                      <li>
                        <FaCheckCircle /> By staying focused
                      </li>
                      <li>
                        <FaCheckCircle /> By hiring and retaining talented and successful employees
                      </li>
                      <li>
                        <FaCheckCircle /> By being fair and ethical at all times
                      </li>
                      <li>
                        <FaCheckCircle /> By reviewing our progress through honest feedback from our employees.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ==================== Faq area end ====================*/}
    </>
  );
};

export default FaqAreaOne;
